export default __webpack_public_path__ + "static/media/ham_slide.85f7ac5d.svg";